const FACEBOOK_BASE_SHARER_URL = 'https://www.facebook.com/sharer/sharer.php'
const X_BASE_SHARER_URL = 'https://twitter.com/intent/tweet'
const LINKEDIN_BASE_SHARER_URL = 'https://www.linkedin.com/sharing/share-offsite'

export const twitterSharerLink = (url: string, message: string) => {
	return `${X_BASE_SHARER_URL}?url=${url}&text=${message}`
}

export const facebookSharerLink = (url: string) => {
	return `${FACEBOOK_BASE_SHARER_URL}?u=${url}`
}

export const linkedinSharerLink = (url: string) => {
	return `${LINKEDIN_BASE_SHARER_URL}?url=${url}`
}

export const mailSharerLink = (url: string) => {
	return `mailto:?body=${url}`
}

export const copyToClipboard = async (
	value: string,
) => {
	if (navigator.clipboard) {
		await navigator.clipboard.writeText(value)
	} else {
		const textArea = document.createElement('textarea')
		textArea.value = value
		document.body.appendChild(textArea)
		textArea.focus()
		textArea.select()
		try {
			document.execCommand('copy')
		} catch (err) {
			console.error('Unable to copy to clipboard', err)
		}
		document.body.removeChild(textArea)
	}
}
